import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  wrapper: {
    width: '560px',
    minHeight: '250px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: '12px',
  },
  row: {
    marginTop: '8px',
  },
  details: {
    gap: '8px',
  },
  hoursRow: {
    marginTop: '8px',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
  },
  formFieldContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
  originalHoursContainer: {
    minHeight: theme => theme.spacing(4),
  },
  newHoursColumn: {
    width: '240px',
    flexShrink: 0,
  },
  label: {
    flexShrink: 0,
    margin: 0,
  },
  value: {
    color: COLORS.black60,
    fontWeight: 600,
  },
  descriptionLabel: {
    display: 'block',
    marginBottom: '4px',
  },
  textarea: {
    width: '100%',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: '48px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
});

export default styles;
